module.exports = __webpack_public_path__ + "img/frontdeskfull.ff0900e5.jpg";